export const T = {
  en_GB: {
    frozenEmpty: "The lookup was not run before the flow was completed.",
    searchFailed: "Search failed",
    unexpectedError: "An unexpected error occurred",
  },
  nb_NO: {
    frozenEmpty: "Oppslaget ble ikke kjørt før flyten ble fullført.",
    searchFailed: "Søket feilet",
    unexpectedError: "En uventet feil oppstod",
  },
} as const;
